<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>内部管理</el-breadcrumb-item>
            <el-breadcrumb-item>训练平板</el-breadcrumb-item>
            <el-breadcrumb-item>游戏分类</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card">
          <!-- 游戏分类列表 strat -->
          <el-tab-pane name="first" label="游戏分类列表">
            <!-- 筛选条件 start -->
            <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
              <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
              </el-form-item>
            </el-form>
            <!-- 筛选条件 end -->
            <el-table :data="dataList" border stripe>
              <el-table-column prop="Id" label="编号" width="80px"></el-table-column>
              <el-table-column prop="Rank" label="排序" width="80px"></el-table-column>
              <el-table-column prop="Name" label="分类名称"></el-table-column>
              <el-table-column prop="Iconopen" label="分类图标开"></el-table-column>
              <el-table-column prop="Iconclose" label="分类图标关"></el-table-column>
              <el-table-column prop="Createtime" label="创建时间" width="200px"></el-table-column>
              <el-table-column prop="operation" label="操作" width="200px">
                <template v-slot="scope">
                  <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModify(scope.$index,scope.row)">修改</el-button>
                  <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 修改游戏分类弹出框 start -->
            <el-dialog title="修改游戏分类" :visible.sync="modify" width="30%" :close-on-click-modal="false">
              <el-form :model="editForm" ref="editFormRef" label-width="70px">
                <el-form-item label="排序" class="addAdminForm">
                  <el-input v-model="editForm.rank" placeholder="请输入排序"></el-input>
                </el-form-item>

                <el-form-item label="分类名称" class="addAdminForm">
                  <el-input v-model="editForm.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>

                <el-form-item label="分类图标开" class="addAdminForm">
                  <el-input v-model="editForm.iconopen" placeholder="请输入分类图标"></el-input>
                </el-form-item>

                <el-form-item label="分类图标关" class="addAdminForm">
                  <el-input v-model="editForm.iconclose" placeholder="请输入分类图标"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="clickedit">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!-- 修改游戏分类弹出框 end -->

          </el-tab-pane>
          <!-- 游戏分类列表 end -->

          <!-- 添加游戏分类 start -->
          <el-tab-pane name="second" label="添加游戏分类">
            <el-form :model="addForm" ref="addFormRef" label-width="70px">
              <el-form-item label="排序" class="addAdminForm">
                <el-input v-model="addForm.rank" placeholder="请输入排序"></el-input>
              </el-form-item>

              <el-form-item label="分类名称" class="addAdminForm">
                <el-input v-model="addForm.name" placeholder="请输入分类名称"></el-input>
              </el-form-item>

              <el-form-item label="分类图标开" class="addAdminForm">
                <el-input v-model="addForm.iconopen" placeholder="请输入分类图标"></el-input>
              </el-form-item>

              <el-form-item label="分类图标关" class="addAdminForm">
                <el-input v-model="addForm.iconclose" placeholder="请输入分类图标"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="clickadd">添加</el-button>
                <el-button type="info" @click="clickreturn">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 添加游戏分类 end -->
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyTrainPadGameSort',
  data () {
    return {
      activeName: 'first',
      addForm: {
        rank: '',
        name: '',
        iconopen: '',
        iconclose: ''
      },
      editForm: {
        id: '',
        rank: '',
        name: '',
        iconopen: '',
        iconclose: ''
      },
      dataList: [],
      modify: false,
      keywords: {
        jigouid: '-1',
        jigouname: ''
      }
    }
  },
  mounted () {
    this.apiGetTrainPadGameSortlist()
  },
  methods: {
    clicksearch () {
      this.apiGetTrainPadGameSortlist()
    },
    clickDelete (index, row) {
      this.$confirm('是否删除此游戏分类?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteTrainPadGameSort(row.Id)
      })
    },
    clickadd () {
      if (!this.addForm.rank) {
        this.$alert('请输入排序', '提示')
        return
      }
      if (!this.addForm.name) {
        this.$alert('请输入分类名称', '提示')
        return
      }
      if (!this.addForm.iconopen) {
        this.$alert('请输入分类图标开', '提示')
        return
      }
      if (!this.addForm.iconclose) {
        this.$alert('请输入分类图标关', '提示')
        return
      }
      this.apiAddTrainPadGameSort()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickModify (index, row) {
      this.editForm.id = row.Id
      this.editForm.rank = row.Rank
      this.editForm.name = row.Name
      this.editForm.iconopen = row.Iconopen
      this.editForm.iconclose = row.Iconclose
      this.modify = true
    },
    clickedit () {
      if (!this.editForm.rank) {
        this.$alert('请输入排序', '提示')
        return
      }
      if (!this.editForm.name) {
        this.$alert('请输入分类名称', '提示')
        return
      }
      if (!this.editForm.iconopen) {
        this.$alert('请输入分类图标开', '提示')
        return
      }
      if (!this.editForm.iconclose) {
        this.$alert('请输入分类图标关', '提示')
        return
      }
      this.apiEditTrainPadGameSort()
    },
    apiGetTrainPadGameSortlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTrainPadGameSortlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddTrainPadGameSort: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        rank: this.addForm.rank,
        name: this.addForm.name,
        iconopen: this.addForm.iconopen,
        iconclose: this.addForm.iconclose
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddTrainPadGameSort, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameSortlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditTrainPadGameSort: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        rank: this.editForm.rank,
        name: this.editForm.name,
        iconopen: this.editForm.iconopen,
        iconclose: this.editForm.iconclose
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditTrainPadGameSort, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameSortlist()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.modify = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteTrainPadGameSort: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteTrainPadGameSort, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameSortlist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
